//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'

import FilesField from '../../components/File/FilesField.vue'
import FilesGroup from '../../components/File/FilesGroup.js'
import DateTimeField from '../../components/Field/DateTimeField.vue'
import CarWashActSelectionDialog from './CarWashAndFuelingActSelectionDialog.vue'
import { journalRecordFilesGroups } from '../../components/File/JournalRecordFilesGroups.js'

export default {
  components: {
    CarWashActSelectionDialog,
    DateTimeField,
    FilesField
  },
  mixins: [journalRecordFilesGroups],
  props: {
    recordId: {
      type: Number,
      default: null
    },
    washingFinish: {
      type: Boolean,
      default: false
    },
    employeeCards: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      record: {
        vehicle: null,
        vehicleType: null,
        odometerValue: null,
        card: {
          id: null,
          number: null
        },
        comment: null,

        id: null,
        name: null,
        stateId: null,
        stateName: null,
        time: null,
        visTransactionTime: null,
        changeTime: null,
        startWashingTime: null,
        endWashingTime: null,
        employeeFIO: null,
        tripNumber: null,
        waybillId: null,
        waybillName: null,

        odometerPhoto: null,
        receiptPhoto: null,
        washingProcessPhoto: null,

        integrationActId: null,
        integrationActName: null,
        useIntegration: null,

        actOriginTypeCode: null,
        actOriginTypeName: null,
        actStatusName: null,
        actStatusCode: null,
        supplierName: null,
        supplierCode: null,

        washingCost: null,
        washingDiscount: null,
        servicePointId: null,
        adjustment: []
      },

      vehicles: [],
      cards: [],
      integrationActs: [],
      waybills: [],
      refuels: [],
      optionsRefuels: [],
      adjustments: [],

      washingOpened: false,

      tempVehicle: null,
      showVehiclesTable: false,

      tempCard: null,
      showCardsTable: false,

      tempWaybill: null,
      showWaybills: false,

      tempIntegrationAct: null,
      showIntegrationActs: false,

      convertTime: convertTime,

      loading: false,

      modalOpened: false,

      rules: {},

      // === Конфигурация групп файлов -> journalRecordFilesGroups
      documentUploadURL: '/service/delta/carwashact/uploadphoto' // Override
      // ??? documentRemoveURL:  // Override
    }
  },
  computed: {
    roleAdmin: function () {
      const user = this.$store.getters.getUser
      const roles = user.roles || {}
      return !!roles.root || !!roles.admin || !!roles.transportAdmin
    },
    integrationActEditable: function () {
      return this.record.useIntegration && (this.record.stateId !== 'CW3' || this.roleAdmin)
    },
    cardEditable: function () {
      return this.record.stateId !== 'CW3' && this.record.actOriginTypeCode !== 'serviceSupplier' && this.record.actOriginTypeCode !== 'serviceSupplierAdjust'
    },
    vehicleEditable: function () {
      return this.record.stateId !== 'CW3'
    },
    waybillEditable: function () {
      return this.record.stateId !== 'CW3'
    }
  },
  watch: {
    '$route.params.id': {
      handler: function (value) {
        this.$q.loading.show({
          message: 'Обновление данных формы акта о мойке ТС...',
          messageColor: 'blue-11',
          spinnerColor: 'blue-11'
        })
        if (value && value !== 'create') {
          this.record.id = value
          if (value != null) {
            this.load()
          }
        } else {
          this.prepareFilesGroups()
          this.$q.loading.hide()
        }
      },
      immediate: true
    },
    recordId: {
      handler: function (value) {
        if (value) {
          this.$q.loading.show({
            message: 'Обновление данных ...',
            messageColor: 'blue-11',
            spinnerColor: 'blue-11'
          })
          this.record.id = value
          if (value != null) {
            this.load()
          } else {
            this.$q.loading.hide()
            this.prepareFilesGroups()
          }
        }
      },
      immediate: true
    }
  },
  created: function () {
    this.getRefuels()

    if (this.washingFinish) {
      this.getFuelCards('otherOnly')
    } else {
      this.getFuelCards('all')
    }
  },
  methods: {
    // Override
    getRecordId: function () {
      let recordId = this.recordId
      if (this.record && this.record.id) {
        recordId = this.record.id
      }
      return recordId || -1
    },
    //
    filterRefuels (val, update) {
      if (val === '') {
        update(() => {
          this.optionsRefuels = this.refuels
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsRefuels = this.refuels.filter((refuel) => {
          return refuel.name.toLowerCase().indexOf(str) > -1
        })
      })
    },
    onShowVehiclesTable: function () {
      this.getVehicles()
      this.tempVehicle = this.record.vehicle
      this.modalOpened = true
      this.showVehiclesTable = true
    },
    onVehicleSelected: function (vehicle) {
      this.tempVehicle = vehicle
    },
    onSaveVehicleSelection: function () {
      this.record.vehicle = this.tempVehicle
      this.record.odometerValue = +this.tempVehicle.odometerValue
      this.onCloseVehicleModal()
    },
    onCloseVehicleModal: function () {
      this.tempVehicle = null
      this.modalOpened = false
      this.showVehiclesTable = false
    },
    onShowCardsTable: function () {
      if (this.record.actOriginTypeCode === 'serviceSupplier') {
        return
      }
      this.tempCard = this.record.card
      this.modalOpened = true
      this.showCardsTable = true
    },
    onCardSelected: function (card) {
      this.tempCard = card
    },
    onSaveCardSelection: function () {
      this.record.card = this.tempCard
      this.onCloseCardModal()
    },
    onCloseCardModal: function () {
      this.tempCard = null
      this.modalOpened = false
      this.showCardsTable = false
    },
    onShowIntegrationActs: function () {
      this.getIntegrationActs()
      this.tempIntegrationAct = { id: this.record.integrationActId, name: this.record.integrationActName }
      this.modalOpened = true
      this.showIntegrationActs = true
    },
    onIntegrationActSelected: function (act) {
      this.tempIntegrationAct = act
    },
    onDeleteIntegrationAct: function () {
      if (this.record.integrationActId) {
        this.$d_ask({
          callback: () => {
            this.save()
              .then(() => {
                this.record.integrationActId = null
                this.link()
              })
          },
          header: 'Удалить привязанный интеграционный акт о мойке транспортного средства?'
        })
      }
    },
    onSaveIntegrationActSelection: function () {
      if (this.record.integrationActId !== this.tempIntegrationAct.id) {
        this.record.integrationActName = this.tempIntegrationAct.name
        this.record.integrationActId = this.tempIntegrationAct.id
        this.onCloseIntegrationActsModal()
        this.save()
          .then((res) => {
            this.link()
          })
          .catch((res) => {
            this.record.integrationActName = null
            this.record.integrationActId = null
          })
      } else {
        this.onCloseIntegrationActsModal()
      }
    },
    onCloseIntegrationActsModal: function () {
      this.tempIntegrationAct = null
      this.modalOpened = false
      this.showIntegrationActs = false
    },
    onShowWaybillsTable: function () {
      this.tempWaybill = { id: this.record.waybillId, name: this.record.waybillName }
      this.modalOpened = true
      this.showWaybills = true
    },
    onWaybillSelected: function (waybill) {
      this.tempWaybill = waybill
      this.getVehicleFromWaybill(waybill.vehicleId)
    },
    onSaveWaybillSelection: function () {
      this.record.waybillId = this.tempWaybill.id
      this.record.waybillName = this.tempWaybill.name
      this.onCloseWaybillsModal()
      this.record.vehicle = this.tempVehicle
      this.tempVehicle = null
    },
    onCloseWaybillsModal: function () {
      this.tempWaybill = null
      this.modalOpened = false
      this.showWaybills = false
    },
    getVehicleFromWaybill: function (vehicleId) {
      axiosGet({
        url: 'service/delta/vehicle/get?id=' + vehicleId,
        onSuccess: (response) => {
          const result = response.data
          this.tempVehicle = result
        },
        onFailure: (response) => {
          this.$q.loading.hide()
          const mes = response.message ? response.message : 'Ошибка получения данных по ТС!'
          this.$q.notify({
            type: 'negative',
            message: mes,
            progress: true,
            timeout: 10000
          })
        }
      })
    },
    onRemoveWaybill: function (id) {
      this.$d_ask({
        callback: () => {
          this.removeWaybill(id)
        },
        header: 'Удалить рейс?'
      })
    },
    removeWaybill: function (id) {
      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('id', id)

      axiosPost({
        url: '/service/delta/carwashact/removeWaybill',
        data: bodyFormData,
        onSuccess: (response) => {
          this.load()
        },
        onFailure: (response) => {
          this.$q.loading.hide()
          const mes = response.message ? response.message : 'Ошибка удаления акта'
          this.$q.notify({
            type: 'negative',
            message: mes,
            progress: true,
            timeout: 10000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    close: function () {
      if (this.washingFinish) {
        this.$emit('close')
      } else {
        if (window.history.length != 1 && window.history.state !== null) {
          this.$router.back()
        } else {
          this.$router.push('/')
        }
      }
    },
    save: function () {
      const validPhotosMessages = this.getFilesGroupsValidationMessages()

      const validFields = []
      if (this.$refs.startWashingTime && !this.$refs.startWashingTime.validate()) {
        validFields.push(this.$refs.startWashingTime.label.charAt(0).toUpperCase() + this.$refs.startWashingTime.label.slice(1).toLowerCase())
      }
      if (this.$refs.endWashingTime && !this.$refs.endWashingTime.validate()) {
        validFields.push(this.$refs.endWashingTime.label.charAt(0).toUpperCase() + this.$refs.endWashingTime.label.slice(1).toLowerCase())
      }
      if (this.$refs.vehicle && !this.$refs.vehicle.validate()) {
        validFields.push(this.$refs.vehicle.label.charAt(0).toUpperCase() + this.$refs.vehicle.label.slice(1).toLowerCase())
      }
      if (this.$refs.card && !this.$refs.card.validate()) {
        validFields.push(this.$refs.card.label.charAt(0).toUpperCase() + this.$refs.card.label.slice(1).toLowerCase())
      }
      if (this.$refs.waybillName && !this.$refs.waybillName.validate()) {
        validFields.push(this.$refs.waybillName.label.charAt(0).toUpperCase() + this.$refs.waybillName.label.slice(1).toLowerCase())
      }

      if (validPhotosMessages.length === 0 && validFields.length === 0) {
        return this.addRecord()
      } else {
        let message = ''
        if (validFields.length > 0) {
          message += 'Не заполнены обязательные поля: ' + validFields.map(val => '"' + val + '"').join(', ') + '.\n'
        }
        if (validPhotosMessages.length > 0) {
          message += 'Не прикреплены фотографии ' + validPhotosMessages.join(', ') + '.'
        }

        this.$q.notify({
          type: 'negative',
          message: message,
          progress: true,
          timeout: 30000
        })

        return Promise.reject(Error('Не заполнены обязательные поля'))
      }
    },
    uploadFilesAct: function (id) {
      const oldId = this.record.id
      this.record.id = id
      return this.uploadFiles()
        .then(result => {
          if (result) {
            const validPhotosMessages = this.getFilesGroupsValidationMessages(true)
            if (result.status !== 'positive' || validPhotosMessages.length !== 0) {
              return Promise.reject(Error())
            }
            if (!oldId) {
              this.load()
            }
          }
        }).catch(result => {
          if (result.message) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
          return Promise.reject(Error())
        })
    },
    addRecord: async function () {
      this.$q.loading.show({
        message: 'Изменение данных формы акта...',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })

      const bodyFormData = new FormData()
      if (this.record.id) {
        try {
          await this.uploadFilesAct(this.record.id)
        } catch (error) {
          this.$q.loading.hide()
          return Promise.reject(Error('Ошибка сохранения файлов'))
        }
        bodyFormData.set('id', this.record.id)
      }

      if (this.washingFinish && this.record.vehicleId) {
        bodyFormData.set('vehicle', this.record.vehicleId)
      } else if (this.record.vehicle && this.record.vehicle.id) {
        bodyFormData.set('vehicle', this.record.vehicle.id)
      }

      if (this.record.odometerValue) {
        bodyFormData.set('odometerValue', +this.record.odometerValue)
      }

      if (this.record.card && this.record.card.id) {
        bodyFormData.set('fuelCardId', this.record.card.id)
      }

      if (this.record.comment) {
        bodyFormData.set('comment', this.record.comment)
      }

      bodyFormData.set('finishWashing', true)

      if (this.record.useIntegration !== null) {
        bodyFormData.set('useIntegration', this.record.useIntegration)
      }
      if (this.record.waybillId) {
        bodyFormData.set('waybill', this.record.waybillId)
      }
      if (this.record.servicePointId) {
        bodyFormData.set('servicePointId', this.record.servicePointId)
      }

      if (!this.record.id && this.record.startWashingTime) {
        bodyFormData.set('startWashingTime', this.record.startWashingTime)
      }
      if (!this.record.id && this.record.endWashingTime) {
        bodyFormData.set('endWashingTime', this.record.endWashingTime)
      }

      if (!this.record.useIntegration) {
        if (this.record.washingCost) {
          bodyFormData.set('washingCost', this.record.washingCost)
        }
        if (this.record.washingDiscount) {
          bodyFormData.set('discount', this.record.washingDiscount)
        }
      }

      return axiosPost({
        url: 'service/delta/carwashact/save',
        data: bodyFormData,
        onSuccess: async (response) => {
          this.$q.loading.hide()
          this.$q.notify({
            type: 'positive',
            message: 'Успешное сохранение акта',
            progress: true,
            timeout: 3000
          })

          if (this.record.id === null) {
            try {
              this.uploadFilesAct(response.data.id)
            } finally {
              this.$router.replace('/transport/carWashAct/' + response.data.id)
              EventBus.$emit('update-carWashAct', {})
            }
          } else {
            if (this.washingFinish) {
              this.$emit('washing-act-finished')
              this.close()
            } else {
              this.load()
              EventBus.$emit('update-carWashAct', {})
            }
          }

          return Promise.resolve(response)
        },
        onFailure: (response) => {
          this.$q.loading.hide()
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка сохранения акта',
            progress: true,
            timeout: 8000
          })
          return Promise.reject(Error('Ошибка сохранения акта'))
        },
        msgTarget: this
      }).finally(() => this.$q.loading.hide())
    },
    CW03_Ready: function () {
      this.save().then(() => {
        this.loading = true

        const bodyFormData = new FormData()
        bodyFormData.set('objectId', this.record.id)

        axiosPost({
          url: '/service/delta/carwash/' + 'CW3',
          data: bodyFormData,
          onSuccess: async (response) => {
            this.$q.notify({
              type: 'positive',
              message: 'Успешная установка состояния готовности акта',
              progress: true,
              timeout: 3000
            })

            await this.load()
            EventBus.$emit('update-carWashAct', {})
          },
          onFailure: 'Ошибка установки состояния готовности акта',
          msgTarget: this
        })
          .finally(() => {
            this.loading = false
          })
      })
    },
    CW04_Cancel: function () {
      this.$d_ask({
        callback: () => {
          this.loading = true

          const bodyFormData = new FormData()
          bodyFormData.set('objectId', this.record.id)

          axiosPost({
            url: '/service/delta/carwash/' + 'CW4',
            data: bodyFormData,
            onSuccess: (response) => {
              this.$q.notify({
                type: 'positive',
                message: 'Успешное аннулирование акта',
                progress: true,
                timeout: 3000
              })

              EventBus.$emit('update-carWashAct', {})
              this.close()
            },
            onFailure: 'Ошибка аннулирования записи журнала',
            msgTarget: this
          })
            .finally(() => {
              this.loading = false
            })
        },
        header: 'Аннулировать акт о мойке?'
      })
    },
    load: function () {
      this.loading = true
      return axiosGet({
        url: 'service/delta/carwashact/get?id=' + this.record.id,
        onSuccess: (response) => {
          const result = response.data.result
          const record = this.record
          if (result.id) {
            record.id = result.id
          }
          record.name = result.name
          record.comment = result.comment ? result.comment.comment : null
          record.stateId = result.stateId
          record.stateName = result.stateName
          record.time = result.time
          record.visTransactionTime = result.visTransactionTime
          record.changeTime = result.changeTime
          if (result.startWashingTime) {
            record.startWashingTime = result.startWashingTime
          }
          if (result.endWashingTime) {
            record.endWashingTime = result.endWashingTime
          }
          record.employeeFIO = result.employeeFIO
          record.tripNumber = result.tripNumber
          record.odometerValue = result.odometerValue
          record.useIntegration = result.useIntegration
          record.waybillId = result.waybillId
          record.waybillName = result.waybillName
          record.servicePointId = result.servicePointId

          if (this.washingFinish) {
            if (!result.card && this.employeeCards.length === 1) {
              this.record.card = this.employeeCards[0]
            } else {
              this.record.card = result.fuelCard
            }

            record.vehicleId = result.vehicleId
            if (result.vehicleId) {
              this.getOdometerValue(result.vehicleId)
            }

            if (record.id) {
              axiosGet({
                url: '/service/delta/carwashact/nearestCarWash?id=' + record.id,
                onSuccess: (response) => {
                  if (response.data && response.data.result) {
                    record.servicePointId = response.data.result.id
                  }
                },
                onFailure: 'Ошибка загрузки информации по ближайшей АЗК',
                msgTarget: this
              })
            }
          } else {
            record.card = result.fuelCard

            record.vehicle = {
              id: result.vehicleId,
              model: result.vehicleModel,
              gosNumber: result.gosNumber,
              name: result.vehicleName
            }

            record.integrationActId = result.integrationActId
            record.integrationActName = result.integrationActName

            record.actOriginTypeCode = result.actOriginTypeCode
            record.actOriginTypeName = result.actOriginTypeName
            record.actStatusName = result.actStatusName
            record.actStatusCode = result.actStatusCode
            record.supplierName = result.supplierName
            record.supplierCode = result.supplierCode

            record.washingCost = result.washingCost
            record.washingDiscount = result.washingDiscount
            record.address = result.servicePointAddress
            record.adjustment = result.adjustment

            if (record.adjustment) {
              let newWashingCost = record.washingCost

              for (let i = 0; i < record.adjustment.length; i++) {
                if (record.adjustment[i].washingCost) {
                  newWashingCost += record.adjustment[i].washingCost
                }
              }

              if (newWashingCost !== record.washingCost && record.washingCost) {
                newWashingCost = Math.round(newWashingCost * 100) / 100
                record.washingCost = newWashingCost + ' (без учёта корректировки ' + record.washingCost + ')'
              }
            }
          }

          record.photoBefore = result.photoBefore
          record.photoAfter = result.photoAfter
          record.receiptPhoto = result.receiptPhoto
          record.odometerPhoto = result.odometerPhoto
          this.prepareFilesGroups()
        },
        onFailure: 'Ошибка загрузки акта о мойке',
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
        if (this.record.actStatusCode === 'manual' || this.record.actStatusCode === 'auto' || this.record.actOriginTypeCode === 'serviceSupplier') {
          this.washingOpened = true
        }
        if (this.washingFinish) {
          this.getFilesGroupsValidationMessages()
        }
        this.loading = false
      })
    },
    prepareFilesGroups: function () {
      this.clearFilesGroups()
      if (this.record) {
        const date = this.record.startWashingTime
        const readOnly = false // this.washingFinish
        const listFilesGroup = {
          photoBefore: { title: 'ФОТО ТС ДО МОЙКИ', documentType: 'before', props: { required: false, validationMessage: 'до мойки' } },
          photoAfter: { title: 'ФОТО ТС ПОСЛЕ МОЙКИ', documentType: 'after', props: { required: false, validationMessage: 'после мойки' } },
          receiptPhoto: { title: 'ФОТО КАССОВОГО ЧЕКА МОЙКИ', documentType: 'receipt', props: { required: true, validationMessage: 'кассового чека мойки' } },
          odometerPhoto: { title: 'ФОТО ОДОМЕТРА', documentType: 'odometer', props: { required: false, validationMessage: 'одометра' } }
        }
        if (!this.record.imagesFilesGroup) {
          this.$set(this.record, 'imagesFilesGroup', {})
        }
        Object.keys(listFilesGroup).forEach(key => {
          if (this.record.imagesFilesGroup[key] === undefined) {
            this.$set(this.record.imagesFilesGroup, key, new FilesGroup({
              key: key,
              categoryKey: key,
              title: listFilesGroup[key].title,
              readonly: readOnly,
              documentType: listFilesGroup[key].documentType,
              props: { required: listFilesGroup[key].props.required, validationMessage: listFilesGroup[key].props.validationMessage, collapseId: key + '_collapse' }
            }))
            this.filesGroups.push(this.record.imagesFilesGroup[key])
          }
          if (this.record[key] && this.record[key].id) {
            const id = this.record[key].id
            this.record.imagesFilesGroup[key].pushFile({
              id: id,
              name: 'Фотография ' + listFilesGroup[key].props.validationMessage + '_' + date
            })
            // this.$set(this.record.imagesFilesGroup, 'photoBefore', ...)
          }
        })
        this.getFilesGroupsValidationMessages()
        this.loadPreloadedFiles()
      }
    },
    /* onFileAddToUpload: function (fileWrapper, key) {
      if (!this.receiptPhotoToUpload && !this.record.receiptPhoto && key == 'receiptPhoto') {
        this.receiptPhotoToUpload = fileWrapper
      }
      this.uploadFiles()
        .then(result => {
          if ((result)) {
            if (result.status !== 'positive') {
              return Promise.reject(Error())
            } else {
              const results = result.results
              results.forEach(item => {
                if (item.status == 'fulfilled') {
                  this.record.imagesFilesGroup[key].clear()
                  this.record.imagesFilesGroup[key].pushFile({
                    id: item.value.data.id,
                    name: 'Фотография ' + this.record.imagesFilesGroup[key].props.validationMessage + '_'
                  })
                }
              })
            }
          }
        }).catch(result => {
          if (result.message) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
        })
    }, */
    link: function () {
      this.loading = true
      const bodyFormData = new FormData()

      let operationMessage = 'удаление интеграционного акта'
      bodyFormData.set('id1', this.record.id)

      if (this.record.integrationActId) {
        operationMessage = 'связывание интеграционных актов'
        bodyFormData.set('id2', this.record.integrationActId)
      }

      axiosPost({
        url: '/service/delta/carwashact/link',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное ' + operationMessage,
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка ' + operationMessage,
        msgTarget: this
      })
        .finally(() => {
          this.load()
          this.loading = false
        })
    },
    getVehicles: function () {
      this.loading = true

      axiosGet({
        url: 'service/delta/vehicle/list',
        onSuccess: (response) => {
          this.vehicles = response.data
        },
        onFailure: 'Ошибка загрузки списка доступных транспортных средств',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getFuelCards: function (owningMode) {
      this.loading = true

      axiosGet({
        url: '/service/delta/fuelCard/list?owningMode=' + owningMode,
        onSuccess: (response) => {
          response.data.result.sort((a, b) => {
            if (a.order && b.order) {
              return a.order - b.order
            } else if (a.order) {
              return -1
            } else if (b.order) {
              return 1
            } else {
              return String(a.number).localeCompare(b.number)
            }
          })

          if (this.washingFinish) {
            this.cards = [
              { key: 'personal', name: 'Свои топливные карты', children: this.employeeCards },
              { key: 'other', name: 'Чужие топливные карты', children: response.data.result }
            ]
          } else {
            this.cards = response.data.result
          }
        },
        onFailure: 'Ошибка загрузки списка чужих топливных карт',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getIntegrationActs: function () {
      this.loading = true
      const params = [
        { param: 'actOriginType', type: 'listvalue', action: '=', value: 'serviceSupplier' },
        { param: 'actStatus', type: 'listvalue', action: '=', value: 'undefined' },
        { param: 'cardNumber', type: 'string', action: 'any' },
        { param: 'servicePointAddress', type: 'string', action: 'any' },
        { param: 'washingCost', type: 'string', action: 'any' },
        { param: 'visTransactionDate', type: 'datetime', action: '>', value: this.record.startWashingTime - 60 * 60 * 1000 },
        { param: 'visTransactionDate', type: 'datetime', action: '<', value: this.record.endWashingTime ? this.record.endWashingTime : this.record.startWashingTime + 60 * 60 * 1000 }
      ]
      const encodeParams = encodeURI(JSON.stringify(params))
      axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&nameField=name&paramsOperation=and&type=carWashAct&subtypes=true&start=0&limit=5000&sort=createtime&dir=DESC',
        onSuccess: (response) => {
          this.integrationActs = response.data.result
        },
        onFailure: 'Ошибка загрузки интеграционных актов',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getOdometerValue: function (vehicleId) {
      this.loading = true
      axiosGet({
        url: '/service/delta/vehicle/get?id=' + vehicleId,
        onSuccess: (response) => {
          const vehicle = response.data
          this.record.odometerValue = +vehicle.odometerValue
        },
        onFailure: 'Ошибка загрузки информации по транспортному средству',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getRefuels: function () {
      this.loading = true

      axiosGet({
        url: '/service/obj/search?&nameField=name&paramsOperation=and&type=carWash&subtypes=true&start=0&limit=5000',
        onSuccess: (response) => {
          this.refuels = response.data.result
        },
        onFailure: 'Ошибка загрузки моек',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    onOpenWaybill: function () {
      if (this.record.waybillId) {
        this.$router.push('/transport/waybill/' + this.record.waybillId)
      }
    },
    getColorState: function () {
      let color = ''
      if (this.record && this.record.actOriginTypeCode !== 'serviceSupplier') {
        const stateId = this.record.stateId
        switch (stateId) {
          case 'CW3':
            color = 'green-11'
            break
          case 'CW4':
            color = 'red-2'
            break
          default:
            color = this.record.actStatusCode === 'undefined' ? 'red-2' : 'lime-2'
            break
        }
      }
      return color
    },
    getParamsSelection: function () {
      const params = {
        items: [],
        itemsForm: [],
        selectedItem: null,
        type: 'default'
      }
      let itemsForm = []
      if (this.showVehiclesTable) {
        let recordVehicle = 'Не выбрано'
        let tempVehicle = 'Не выбрано'
        if (this.record && this.record.vehicle) {
          recordVehicle = (this.record.vehicle.name ? this.record.vehicle.name + ' ' : '')
          recordVehicle += this.record.vehicle.model + ' ' + this.record.vehicle.gosNumber
        }
        if (this.tempVehicle) {
          tempVehicle = this.tempVehicle.name + ' ' + this.tempVehicle.model + ' ' + this.tempVehicle.gosNumber
        }
        itemsForm = [
          { key: 'vehicle', name: 'Транспортное средство в записи журнала', value: recordVehicle, show: recordVehicle !== 'Не выбрано' },
          { key: 'tempVehicle', name: 'Текущее выбранное транспортное средство', value: tempVehicle, show: true }
        ]
        this.$set(params, 'items', this.vehicles)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.record ? this.record.vehicle : null)
        this.$set(params, 'type', 'showVehiclesTable')
        this.$set(params, 'title', 'Выбор транспортного средства')
      } else if (this.showCardsTable) {
        let recordCard = 'Не выбрана'
        let tempCard = 'Не выбрана'
        if (this.record && this.record.card) {
          recordCard = this.record.card.number
        }
        if (this.tempCard) {
          tempCard = this.tempCard.number
        }
        itemsForm = [
          { key: 'card', name: 'Карта в записи журнала', value: recordCard, show: recordCard !== 'Не выбрана' },
          { key: 'tempCard', name: 'Текущая выбранная карта', value: tempCard, show: true }
        ]
        this.$set(params, 'items', this.cards)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.record && this.record.card ? this.record.card : null)
        this.$set(params, 'type', 'showCardsTable')
        this.$set(params, 'title', 'Выбор карты')
      } else if (this.showIntegrationActs) {
        let tempIntegrationAct = 'Не выбран'
        if (this.tempIntegrationAct) {
          tempIntegrationAct = this.tempIntegrationAct.name
        }
        itemsForm = [
          { key: 'tempIntegrationAct', name: 'Выбранный акт', value: tempIntegrationAct, show: true }
        ]
        this.$set(params, 'items', this.integrationActs)
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', this.tempIntegrationAct)
        this.$set(params, 'type', 'showIntegrationActs')
        this.$set(params, 'title', 'Выбор интеграционного акта')
      } else if (this.showWaybills) {
        let tempWaybill = 'Не выбран'
        if (this.tempWaybill && this.tempWaybill.name) {
          tempWaybill = this.tempWaybill.name
        }
        itemsForm = [
          { key: 'tempWaybill', name: 'ТЕКУЩИЙ ВЫБРАННЫЙ РЕЙС:', value: tempWaybill, show: true }
        ]
        this.$set(params, 'items', [])
        this.$set(params, 'itemsForm', itemsForm)
        this.$set(params, 'selectedItem', null)
        this.$set(params, 'type', 'showWaybills')
      }
      return params
    },
    onSaveSelection: function (type) {
      switch (type) {
        case 'showVehiclesTable':
          this.onSaveVehicleSelection()
          break
        case 'showCardsTable':
          this.onSaveCardSelection()
          break
        case 'showIntegrationActs':
          this.onSaveIntegrationActSelection()
          break
        case 'showWaybills':
          this.onSaveWaybillSelection()
          break
        default:
          break
      }
    },
    onCloseSelection: function (type) {
      switch (type) {
        case 'showVehiclesTable':
          this.onCloseVehicleModal()
          break
        case 'showCardsTable':
          this.onCloseCardModal()
          break
        case 'showIntegrationActs':
          this.onCloseIntegrationActsModal()
          break
        case 'showWaybills':
          this.onCloseWaybillsModal()
          break
        default:
          break
      }
    },
    onSelectedItem: function (params) {
      switch (params.type) {
        case 'showVehiclesTable':
          this.onVehicleSelected(params.selectedItem)
          break
        case 'showCardsTable':
          this.onCardSelected(params.selectedItem)
          break
        case 'showIntegrationActs':
          this.onIntegrationActSelected(params.selectedItem)
          break
        case 'showWaybills':
          this.onWaybillSelected(params.selectedItem)
          break
        default:
          break
      }
    }
  }
}

